module.exports = __webpack_public_path__ + "1b3a814f9d28a3d9d5b5fef1482a3aaf.pdf";